var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-edicion',[_c('page-header',{attrs:{"title":"Crear plan","back-to":"/planes"}}),_c('formulario',{attrs:{"plan":_vm.plan},on:{"submit":_vm.insertar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }